import React, {Fragment, useEffect, useState} from "react";
import EANavButton from "../components/EANavButton";
import {optIn} from "../services/DoubleOptInService";
import routes from "../consts/routes.json";
import queryString from "query-string";

/**
 * View für das DoubleOptIn
 * @param location Die URL
 * @returns {JSX.Element}
 * @constructor
 */
function DoubleOptInView({location}) {
    const [doubleOptInSucceded, setDoubleOptInSucceded] = useState(null);
    const {t: token} = queryString.parse(location.search);
    useEffect(() => {
        optIn(token).then(({data}) => {
            setDoubleOptInSucceded(data);
        }).catch(() => setDoubleOptInSucceded(false));
    }, [token]);

    function renderMessage() {
        if (doubleOptInSucceded) {
            return (
                <Fragment>Ihre E-Mail Adresse wurde erfolgreich bestätigt.<br/>
                    Sie können sich einloggen, sobald Ihr Konto durch einen Administrator freigeschaltet wurde.</Fragment>);
        } else if (doubleOptInSucceded === false) {
            return (
                <Fragment>Ihre E-Mail Adresse konnte nicht bestätigt werden!<br/>
                    Eventuell wurde Ihre E-Mail Adresse bereits bestätigt.<br/>
                    Sollten Sie sich nicht einloggen können, obwohl die Bestätigung Ihrer E-Mail Adresse bereits lange erfolgt ist,<br/>
                    wenden Sie sich bitte an einen Administrator!</Fragment>);
        }
        return <Fragment>Ihre E-Mail Adresse wird bestätigt...</Fragment>;
    }

    return <div className="viewContent">
        <h1>E-Mail Bestätigung</h1>
        <p id="optinAntwort" className="centeredText">
            {renderMessage()}
        </p>
        <br/>
        <br/>
        <EANavButton to={routes.LOGIN}>Zum Login</EANavButton>
    </div>;
}

export default DoubleOptInView;
